exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3OdnI{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-align:stretch;align-items:stretch;-ms-flex-pack:justify;justify-content:space-between;height:auto}", ""]);

// exports
exports.locals = {
	"social-share": "_3OdnI",
	"socialShare": "_3OdnI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader??ref--2-2!./node_modules/stylus-loader??ref--2-3!./src/widget/player-widget/components/social-share/social-share.styl
// module id = 1842
// module chunks = mobile/mobile mobile-overlay/mobile-overlay widget/strip widget/classic widget/compact